import {axiosPublic} from '../interceptors';

export const checkUserRole = adminBaseUrl => {
  const url = `${adminBaseUrl}/app-info/health`;
  return axiosPublic.request({url: url, method: 'GET'});
};
